/* Challenge 5 minutes — DailyLama
   Maquette : Claude Design « Challenge 5 minutes.dc.html »
   Deux couches : creerSession() = logique pure (horloge et stockage injectés),
   monter() = branchement DOM. La première est testable en millisecondes. */
(function (global) {
  'use strict';

  var DUREES = [60, 180, 300, 600];
  var DUREE_DEFAUT = 300;
  var CYCLE = 10;      // secondes : un souffle complet
  var INSPIRE = 4;     // secondes : la part inspirée du cycle
  var CLE_JOUR = 'dl-challenge-day';
  var CLE_DATE = 'dl-challenge-date';
  var PALIER = 7;

  function deuxChiffres(n) { return n < 10 ? '0' + n : String(n); }

  function jourCalendaire(ms) {
    var d = new Date(ms);
    return d.getFullYear() + '-' + deuxChiffres(d.getMonth() + 1) + '-' + deuxChiffres(d.getDate());
  }

  /* Stockage tolérant : navigation privée, quota plein, cookies bloqués. */
  function coffreSur(brut) {
    return {
      lire: function (cle) { try { return brut ? brut.getItem(cle) : null; } catch (e) { return null; } },
      ecrire: function (cle, val) { try { if (brut) brut.setItem(cle, val); } catch (e) {} }
    };
  }

  function creerSession(options) {
    options = options || {};
    var horloge = options.horloge || function () { return Date.now(); };
    var coffre = coffreSur(options.stockage);
    var emettre = options.emettre || function () {};

    var etat = 'idle';
    var duree = DUREES.indexOf(options.duree) >= 0 ? options.duree : DUREE_DEFAUT;
    var finPrevue = null;
    var resteEnPause = null;
    var complete = false;
    var son = false;
    var calme = options.calme === true;
    var tempsMasque = false;

    function ecoule() {
      if (etat === 'idle') return 0;
      return duree - restantMs() / 1000;
    }

    function restantMs() {
      if (etat === 'idle') return duree * 1000;
      if (etat === 'paused') return resteEnPause;
      if (etat === 'completed') return 0;
      return Math.max(0, finPrevue - horloge());
    }

    var api = {
      etat: function () { return etat; },
      duree: function () { return duree; },
      calme: function () { return calme; },
      sonActif: function () { return son; },
      tempsMasque: function () { return tempsMasque; },

      choisirDuree: function (n) {
        if (etat !== 'idle') return false;          // jamais en pleine séance
        if (DUREES.indexOf(n) < 0) return false;
        if (n === duree) return false;
        duree = n;
        emettre('meditation_duree_choisie', { duree: n });
        return true;
      },

      demarrer: function () {
        if (etat !== 'idle') return false;
        etat = 'running';
        complete = false;
        finPrevue = horloge() + duree * 1000;
        emettre('meditation_started', { duree: duree });
        return true;
      },

      /* Séparées de basculerPause : l'onglet masqué doit pouvoir suspendre sans
         risquer de relancer une séance déjà en pause. */
      mettreEnPause: function (motif) {
        if (etat !== 'running') return false;
        resteEnPause = restantMs();
        etat = 'paused';
        emettre(motif === 'absence' ? 'meditation_interrompue' : 'meditation_paused',
                { restant: Math.round(resteEnPause / 1000) });
        return true;
      },

      reprendre: function () {
        if (etat !== 'paused') return false;
        finPrevue = horloge() + resteEnPause;
        resteEnPause = null;
        etat = 'running';
        emettre('meditation_resumed', {});
        return true;
      },

      basculerPause: function () { return this.mettreEnPause() || this.reprendre(); },

      quitter: function () {
        if (etat === 'idle') return false;
        var abandonnee = etat !== 'completed';
        etat = 'idle';
        finPrevue = null;
        resteEnPause = null;
        if (abandonnee) emettre('meditation_quit', { restant: 0 });
        return true;
      },

      recommencer: function () {
        etat = 'idle';
        complete = false;
        return this.demarrer();
      },

      basculerSon: function () {
        son = !son;
        emettre(son ? 'meditation_son_active' : 'meditation_son_coupe', {});
        return son;
      },

      basculerCalme: function () { calme = !calme; return calme; },

      basculerTemps: function () {
        tempsMasque = !tempsMasque;
        emettre(tempsMasque ? 'meditation_temps_masque' : 'meditation_temps_affiche', {});
        return tempsMasque;
      },

      restantMs: restantMs,
      restantSecondes: function () { return Math.max(0, Math.ceil(restantMs() / 1000)); },

      horloge: function () {
        var s = this.restantSecondes();
        return Math.floor(s / 60) + ':' + deuxChiffres(s % 60);
      },

      progression: function () {
        if (etat === 'idle') return 0;
        var fait = duree - this.restantSecondes();
        return Math.min(100, Math.max(0, (fait / duree) * 100));
      },

      /* La phase se déduit du temps écoulé : juste au retour d'onglet, sans resynchronisation. */
      phase: function () {
        if (etat === 'paused') return { nom: 'pause', libelle: 'Pause' };
        if (etat !== 'running') return { nom: 'idle', libelle: '' };
        var dans = ecoule() % CYCLE;
        return dans < INSPIRE
          ? { nom: 'inspire', libelle: 'Inspirez' }
          : { nom: 'expire', libelle: 'Expirez' };
      },

      /* Appelé à chaque frame : renvoie true uniquement à l'instant de la complétion. */
      rafraichir: function () {
        if (etat !== 'running') return false;
        if (restantMs() > 0) return false;
        if (complete) return false;
        complete = true;
        etat = 'completed';
        emettre('meditation_completed', { duree: duree });
        this.enregistrerJournee();
        return true;
      },

      jour: function () {
        var n = Number(coffre.lire(CLE_JOUR));
        if (!n || n < 1) return 1;
        return Math.min(PALIER, n);
      },

      /* Un jour de challenge = un jour de calendrier, pas une séance.
         Six séances dans la même journée ne font pas passer de « Jour 1 » à « Jour 7 ». */
      enregistrerJournee: function () {
        var aujourdhui = jourCalendaire(horloge());
        if (coffre.lire(CLE_DATE) === aujourdhui) return this.jour();
        var suivant = Math.min(PALIER, this.jour() + (coffre.lire(CLE_DATE) ? 1 : 0));
        coffre.ecrire(CLE_DATE, aujourdhui);
        coffre.ecrire(CLE_JOUR, String(suivant));
        return suivant;
      },

      titreFin: function () {
        var m = duree / 60;
        return m === 1 ? '1 minute rien qu’à vous' : m + ' minutes rien qu’à vous';
      },

      libelleJour: function () { return 'Jour ' + this.jour() + ' sur ' + PALIER; }
    };

    return api;
  }

  global.DailyLamaMeditation = { creerSession: creerSession, DUREES: DUREES, CYCLE: CYCLE, INSPIRE: INSPIRE };

  /* ------------------------------------------------------------------ */
  /* Couche DOM                                                          */
  /* ------------------------------------------------------------------ */

  var API_DEFAUT = 'https://api.dailylama.shop/v1';
  var apiBase = API_DEFAUT;          // remplacé au montage par data-api de la racine

  function pister(nom, props) {
    props = props || {};
    try {
      global.dataLayer = global.dataLayer || [];
      global.dataLayer.push(Object.assign({ event: nom }, props));
    } catch (e) {}
    try {
      global.dispatchEvent(new CustomEvent('dl:meditation', { detail: { nom: nom, props: props } }));
    } catch (e) {}
    try {
      global.fetch(apiBase + '/events', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: nom, props: Object.assign({ source_url: location.pathname }, props) })
      }).catch(function () {});
    } catch (e) {}
  }

  /* Nappe sonore générée : aucun fichier audio, aucun autoplay.
     Le contexte n'est créé qu'au premier clic sur le bouton. */
  function creerNappe() {
    var ctx = null, gain = null, oscs = [];
    return {
      demarrer: function () {
        var Ctx = global.AudioContext || global.webkitAudioContext;
        if (!Ctx) return false;
        if (!ctx) {
          ctx = new Ctx();
          var filtre = ctx.createBiquadFilter();
          filtre.type = 'lowpass';
          filtre.frequency.value = 420;
          gain = ctx.createGain();
          gain.gain.value = 0;
          [110, 164.81, 220].forEach(function (f, i) {
            var o = ctx.createOscillator();
            o.type = 'sine';
            o.frequency.value = f;
            o.detune.value = i * 4 - 4;
            o.connect(filtre);
            o.start();
            oscs.push(o);
          });
          filtre.connect(gain);
          gain.connect(ctx.destination);
        }
        if (ctx.state === 'suspended') ctx.resume();
        gain.gain.cancelScheduledValues(ctx.currentTime);
        gain.gain.setValueAtTime(gain.gain.value, ctx.currentTime);
        gain.gain.linearRampToValueAtTime(0.05, ctx.currentTime + 1.6);
        return true;
      },
      taire: function () {
        if (!ctx || !gain) return;
        gain.gain.cancelScheduledValues(ctx.currentTime);
        gain.gain.setValueAtTime(gain.gain.value, ctx.currentTime);
        gain.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.6);
      },
      fermer: function () {
        this.taire();
        var vieux = ctx;
        ctx = null; gain = null; oscs = [];
        if (vieux) global.setTimeout(function () { try { vieux.close(); } catch (e) {} }, 800);
      }
    };
  }

  function monter(racine) {
    if (!racine || racine.dataset.dlmMonte === 'oui') return null;
    racine.dataset.dlmMonte = 'oui';
    apiBase = racine.getAttribute('data-api') || API_DEFAUT;

    var $ = function (sel) { return racine.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(racine.querySelectorAll(sel)); };

    var scene = $('[data-dlm-scene]');
    var vueSouffle = $('[data-dlm-vue="souffle"]');
    var vueFin = $('[data-dlm-vue="fin"]');
    var boutonsDuree = $$('[data-dlm-duree]');
    var lancer = $('[data-dlm-lancer]');
    var phaseTexte = $('[data-dlm-phase]');
    var mention = $('[data-dlm-mention]');
    var horlogeTexte = $('[data-dlm-horloge]');
    var jauge = $('[data-dlm-jauge]');
    var compteur = $('[data-dlm-compteur]');
    var noteMasque = $('[data-dlm-masque]');
    var titreFin = $('[data-dlm-titre-fin]');
    var pastilleJour = $('[data-dlm-jour]');
    var quitters = $$('[data-dlm-quitter]');
    var recommencer = $('[data-dlm-recommencer]');
    var pauses = $$('[data-dlm-pause]');
    var boutonTemps = $('[data-dlm-temps]');
    var boutonSon = $('[data-dlm-son]');
    var formulaire = $('[data-dlm-optin]');

    var prefereCalme = false;
    try {
      prefereCalme = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}

    var nappe = creerNappe();
    var session = global.DailyLamaMeditation.creerSession({
      stockage: (function () { try { return global.localStorage; } catch (e) { return null; } })(),
      calme: prefereCalme,
      emettre: pister
    });

    var boucle = null;
    var declencheur = null;
    var absent = false;                       // la pause vient-elle d'un départ de l'onglet ?
    var texteMention = mention ? mention.textContent : '';

    function peindreDurees() {
      boutonsDuree.forEach(function (b) {
        var actif = Number(b.dataset.dlmDuree) === session.duree();
        b.setAttribute('aria-checked', actif ? 'true' : 'false');
        b.tabIndex = actif ? 0 : -1;
      });
    }

    function peindreOutils() {
      var masque = session.tempsMasque();
      if (boutonTemps) {
        boutonTemps.setAttribute('aria-pressed', masque ? 'true' : 'false');
        boutonTemps.textContent = masque ? 'Afficher le temps' : 'Masquer le temps';
      }
      if (compteur) compteur.hidden = masque;
      if (noteMasque) noteMasque.hidden = !masque;

      if (boutonSon) {
        var actif = session.sonActif();
        boutonSon.setAttribute('aria-pressed', actif ? 'true' : 'false');
        boutonSon.textContent = actif ? 'Son activé' : 'Son coupé';
      }
      var enPause = session.etat() === 'paused';
      pauses.forEach(function (b) {
        b.textContent = enPause ? 'Reprendre' : 'Pause';
        b.setAttribute('aria-pressed', enPause ? 'true' : 'false');
      });
      scene.dataset.pause = enPause ? 'oui' : 'non';
      scene.dataset.calme = session.calme() ? 'oui' : 'non';
      if (mention) {
        mention.hidden = !enPause;
        mention.textContent = absent
          ? (mention.getAttribute('data-absence') || texteMention)
          : texteMention;
      }
    }

    function peindreTemps() {
      if (horlogeTexte) horlogeTexte.textContent = session.horloge();
      if (jauge) jauge.style.width = session.progression() + '%';
      var p = session.phase();
      if (phaseTexte && phaseTexte.dataset.nom !== p.nom) {
        phaseTexte.dataset.nom = p.nom;
        phaseTexte.textContent = p.libelle;
      }
    }

    function tourner() {
      if (session.rafraichir()) { montrerFin(); return; }
      peindreTemps();
      boucle = global.requestAnimationFrame(tourner);
    }

    function arreterBoucle() {
      if (boucle) global.cancelAnimationFrame(boucle);
      boucle = null;
    }

    /* Piège de focus : la scène couvre la page, la tabulation ne doit pas en sortir. */
    function surTouche(e) {
      if (e.key === 'Escape') { e.preventDefault(); sortir(); return; }
      if (e.key !== 'Tab') return;
      var vue = session.etat() === 'completed' ? vueFin : vueSouffle;
      var cibles = Array.prototype.slice.call(
        vue.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])')
      ).concat(Array.prototype.slice.call(scene.querySelectorAll('[data-dlm-quitter]')))
       .filter(function (el) { return el.offsetParent !== null && !el.disabled; });
      if (!cibles.length) return;
      var premier = cibles[0], dernier = cibles[cibles.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }

    function ouvrirScene() {
      scene.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', surTouche);
    }

    function fermerScene() {
      scene.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', surTouche);
      arreterBoucle();
      nappe.fermer();
      if (declencheur) { try { declencheur.focus(); } catch (e) {} }
    }

    function montrerSouffle() {
      absent = false;
      vueSouffle.hidden = false;
      vueFin.hidden = true;
      /* Relance les keyframes CSS à zéro pour qu'elles coïncident avec le minuteur. */
      scene.querySelectorAll('.dlm__orbe, .dlm__blob, .dlm__halo, .dlm__teinte').forEach(function (el) {
        el.style.animation = 'none';
        void el.offsetWidth;
        el.style.animation = '';
      });
      peindreOutils();
      peindreTemps();
      var sortie = scene.querySelector('[data-dlm-quitter]');
      if (sortie) sortie.focus();
      boucle = global.requestAnimationFrame(tourner);
    }

    function montrerFin() {
      arreterBoucle();
      nappe.taire();
      vueSouffle.hidden = true;
      vueFin.hidden = false;
      if (titreFin) titreFin.textContent = session.titreFin();
      if (pastilleJour) pastilleJour.textContent = session.libelleJour();
      if (titreFin) titreFin.focus();
    }

    function sortir() {
      session.quitter();
      fermerScene();
    }

    /* Anti-triche : quitter l'onglet suspend la séance. Le minuteur suit l'horloge
       murale, donc sans cela le temps passé ailleurs compterait comme du temps assis. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) return;
      if (!session.mettreEnPause('absence')) return;
      absent = true;
      nappe.taire();
      peindreOutils();
      peindreTemps();
    });

    /* ---------- Écoutes ---------- */

    boutonsDuree.forEach(function (b, i) {
      b.addEventListener('click', function () {
        session.choisirDuree(Number(b.dataset.dlmDuree));
        peindreDurees();
      });
      b.addEventListener('keydown', function (e) {
        var pas = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
                : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!pas) return;
        e.preventDefault();
        var suivant = boutonsDuree[(i + pas + boutonsDuree.length) % boutonsDuree.length];
        session.choisirDuree(Number(suivant.dataset.dlmDuree));
        peindreDurees();
        suivant.focus();
      });
    });

    if (lancer) lancer.addEventListener('click', function () {
      declencheur = lancer;
      if (!session.demarrer()) return;
      ouvrirScene();
      montrerSouffle();
    });

    quitters.forEach(function (b) { b.addEventListener('click', sortir); });

    if (recommencer) recommencer.addEventListener('click', function () {
      if (!session.recommencer()) return;
      montrerSouffle();
    });

    pauses.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!session.basculerPause()) return;
        if (session.etat() === 'paused') { nappe.taire(); absent = false; }
        else { absent = false; if (session.sonActif()) nappe.demarrer(); }
        peindreOutils();
        peindreTemps();
      });
    });

    if (boutonTemps) boutonTemps.addEventListener('click', function () {
      session.basculerTemps();
      peindreOutils();
    });

    if (boutonSon) boutonSon.addEventListener('click', function () {
      var actif = session.basculerSon();
      if (actif) {
        if (!nappe.demarrer()) {
          session.basculerSon();                 // pas de WebAudio : on ne ment pas au bouton
          peindreOutils();
          return;
        }
      } else {
        nappe.taire();
      }
      peindreOutils();
    });

    /* ---------- Inscription ---------- */

    if (formulaire) {
      formulaire.addEventListener('submit', function (e) {
        e.preventDefault();
        var champ = formulaire.querySelector('input[type="email"]');
        var coche = formulaire.querySelector('[data-dlm-consent]');
        var bouton = formulaire.querySelector('button[type="submit"]');
        var reponse = formulaire.querySelector('[data-dlm-reponse]');
        var email = (champ.value || '').trim();

        function dire(msg, erreur) {
          reponse.className = 'dlm__reponse' + (erreur ? ' dlm__reponse--erreur' : '');
          reponse.textContent = msg;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
          dire('Cette adresse ne semble pas valide.', true);
          champ.focus();
          return;
        }
        if (coche && !coche.checked) {
          dire('Merci de cocher la case pour recevoir les emails.', true);
          coche.focus();
          return;
        }
        bouton.disabled = true;
        dire('Envoi…', false);
        global.fetch(apiBase + '/events', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: 'meditation_inscription',
            email: email,
            source: 'challenge-5-minutes',
            consent: true,
            props: {
              duree: String(session.duree()),
              jour: String(session.jour()),
              source_url: location.pathname
            }
          })
        }).then(function (r) {
          /* 204 = nom refusé par la liste blanche : le serveur n'a rien enregistré.
             On ne veut surtout pas afficher un succès dans ce cas. */
          if (r.status === 204) throw new Error('non-enregistre');
          if (r.status === 429) throw new Error('trop-de-tentatives');
          if (!r.ok) throw new Error('http-' + r.status);
          dire('C’est noté. Le premier email arrive demain.', false);
          champ.disabled = true;
          if (coche) coche.disabled = true;
          bouton.hidden = true;
        }).catch(function (e) {
          bouton.disabled = false;
          dire(e && e.message === 'trop-de-tentatives'
            ? 'Trop de tentatives depuis cette connexion. Réessayez dans une heure.'
            : 'L’inscription n’a pas pu être enregistrée. Réessayez plus tard.', true);
        });
      });
    }

    peindreDurees();
    peindreOutils();
    pister('meditation_view', { duree: session.duree() });

    return session;
  }

  global.DailyLamaMeditation.monter = monter;

  if (typeof document !== 'undefined') {
    var demarrage = function () {
      Array.prototype.slice.call(document.querySelectorAll('[data-dlm-racine]')).forEach(monter);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrage);
    else demarrage();
  }
})(typeof window !== 'undefined' ? window : globalThis);
